import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Card, MarginImg } from './Styled';

import VerticalBox from 'components/boxes/VerticalBox';
import Tag from 'components/Tag/Tag';
import Button from 'components/buttons/Button';
import WithoutImage from 'images/backgrounds/campaign_without_image.png';

import { useMonthAndDayRange } from 'helpers/dateHelpers';
import { IChallenge } from 'redux/slices/Challenges/Challenges.interface';

const addDefaultPicture = (evt: SyntheticEvent<HTMLImageElement, Event>) => {
  evt.currentTarget.src = WithoutImage;
};

const CallToAction: React.FC<IChallenge> = props => {
  const { id, status } = props;

  const { t } = useTranslation(['campaign_card', 'challenge']);
  const history = useHistory();

  if (status == 'pending') {
    return (
      <Button
        value={t('campaign_section:coming_soon')}
        disabled={true}
        size="medium"
        variant="primary"
      />
    );
  }

  return (
    <Button
      value={
        status == 'completed'
          ? t('campaign_section:see_results')
          : t('campaign_section:participate')
      }
      size="medium"
      variant="primary"
      onClick={() => history.replace({ pathname: `/challenges/detail/${id}` })}
    />
  );
};

const ChallengeCard: React.FC<IChallenge> = props => {
  const { t } = useTranslation(['campaign_card', 'challenge']);
  const {
    photo,
    startDate,
    status,
    finishDate,
    name,
    content,
    facebook,
    twitter,
    linkedin,
    instagram,
    tiktok,
    snapchat,
    youtube,
    threads,
    others,
    format
  } = props;

  const socialNetworks = [
    'facebook',
    'twitter',
    'linkedin',
    'instagram',
    'tiktok',
    'snapchat',
    'youtube',
    'threads',
    'others'
  ];
  const source: { [key: string]: boolean } = {
    facebook,
    twitter,
    linkedin,
    instagram,
    tiktok,
    snapchat,
    youtube,
    threads,
    others
  };

  const socialNetworksActivated = socialNetworks.filter(
    (network: string) => network in source && source[network]
  );

  const dateRange = useMonthAndDayRange(startDate, finishDate);

  return (
    <Card>
      <VerticalBox
        header={
          <div>
            <Tag value={dateRange} variant="normal" />
            <MarginImg>
              <img
                alt="userPhoto"
                onError={evt => addDefaultPicture(evt)}
                src={photo || WithoutImage}
              />
            </MarginImg>
          </div>
        }
        networks={socialNetworksActivated}
        disabled={status == 'pending'}
        className="campaign-card"
      >
        <h2 className={name.length > 50 ? 'overflow-elipsis' : ''}>{name}</h2>
        <p>
          {`${t('challenge:rules')}: `}
          {content}
          <br />
          {`${t('challenge:format')}: `}
          {format}
        </p>
        <CallToAction {...props} />
      </VerticalBox>
    </Card>
  );
};

export default ChallengeCard;
